import React, { useState, useEffect, useRef } from 'react';

import { Modal } from 'flowbite';

import UncommittedExpendituresEditModal from './UncommittedExpendituresEditModal';

import { modalOptions } from 'Helpers/modalOptions';

import Button from 'CommonComponents/Button';

import EditIcon from 'Assets/icons/edit.svg';

export default function CommittedExpendituresCreateList(props) {
    const [uncommittedExpenditures, setUncommittedExpenditures] = useState([]);
    const [updatedUncommittedExpenditure, setUpdatedUncommittedExpenditure] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [isRequesting, setIsRequesting] = useState(false);
    const [errors, setErrors] = useState('');
    const [uncommittedExpendituresEditModalElement, setUncommittedExpendituresEditModalElement] = useState(null);

    const uncommittedExpendituresEditModalRef = useRef();

    useEffect(() => {
        fetchUncommittedExpenditures();
        uncommittedExpendituresEditModalRef &&
            setUncommittedExpendituresEditModalElement(new Modal(uncommittedExpendituresEditModalRef.current, modalOptions(false)));
    }, []);

    useEffect(() => {
        if (Object.keys(updatedUncommittedExpenditure).length > 0) {
            uncommittedExpendituresEditModalElement && uncommittedExpendituresEditModalElement.show();
        }
    }, [updatedUncommittedExpenditure]);

    function clickRow(uncommittedExpenditure) {
        if (uncommittedExpenditure.expense.type === 'sport') {
            return;
        }

        if (uncommittedExpenditure.expense.type === 'project') {
            window.location.href =
                props.committedExpendituresCreateUrl +
                '?uncommittedExpenditureGroupId=' +
                props.uncommittedExpenditureGroupId +
                '&uncommitted_expenditure_id=' +
                uncommittedExpenditure.id;
        } else {
            setUpdatedUncommittedExpenditure(uncommittedExpenditure);
        }
    }

    const successHandler = () => {
        uncommittedExpendituresEditModalElement && uncommittedExpendituresEditModalElement.hide();
        fetchUncommittedExpenditures();
        setUpdatedUncommittedExpenditure({});
    };

    const closeHandler = () => {
        uncommittedExpendituresEditModalElement && uncommittedExpendituresEditModalElement.hide();
        setUpdatedUncommittedExpenditure({});
    };

    const fetchUncommittedExpenditures = () => {
        setIsLoading(true);

        axios
            .get(
                props.committedExpendituresCreateUrl +
                    '?uncommittedExpenditureGroupId=' +
                    props.uncommittedExpenditureGroupId +
                    (props.uncommittedExpenditureId !== '' ? '&uncommitted_expenditure_id=' + props.uncommittedExpenditureId : ''),
            )
            .then((res) => {
                setUncommittedExpenditures(res.data);
                setIsLoading(false);
            })
            .catch((error) => {
                setUncommittedExpenditures([]);
                setIsLoading(false);
            });
    };

    const storeCommittedExpenditures = (isBudgetted) => {
        setIsRequesting(true);

        axios
            .post(props.committedExpendituresStoreUrl, {
                uncommittedExpenditureGroupId: props.uncommittedExpenditureGroupId,
                isBudgetted: isBudgetted,
            })
            .then((res) => {
                if (res.data.status == `ok`) {
                    if (isBudgetted) {
                        window.location.replace(props.committedExpendituresIndexUrl);
                    } else {
                        window.location.replace(props.uncommittedExpendituresCreateUrl);
                    }
                }
                setIsRequesting(false);
            })
            .catch((error) => {
                setErrors(error.response?.data?.errors?.pending_line_change?.[0] ?? error.response.data.error);
                setIsRequesting(false);
            });
    };

    const cancelStoreCommittedExpenditures = (url = null) => {};

    function pageChange(data) {
        const url = combineFetchUrl(data.selected + 1);
        setPage(+data.selected + 1);
        fetchCommittedExpenditures(url);
    }

    const isProjectSblExpense = (uncommittedExpenditure) => {
        return uncommittedExpenditure.expense.project_id !== null && uncommittedExpenditure.expense.type === 'expense';
    };

    return (
        <>
            <div className="row mt-3">
                <div className="col">
                    <div className="card bg-white border-0 rounded-15px shadow py-2">
                        <div className="card-body">
                            <h6 className="text-blue font-weight-600 mb-2">Proceed to commit expenditures</h6>
                            {errors != '' && (
                                <div className="alert alert-danger">
                                    <ul>
                                        <li>{errors}</li>
                                    </ul>
                                </div>
                            )}
                            {isLoading && <p>Loading...</p>}
                            {!isLoading && (
                                <ul className="list-group">
                                    {uncommittedExpenditures.map((uncommittedExpenditure) => {
                                        return (
                                            <li key={uncommittedExpenditure.id} className="list-group-item">
                                                <div onClick={() => clickRow(uncommittedExpenditure)}>
                                                    <label>
                                                        <b>{`${uncommittedExpenditure.expense.name}`}</b>
                                                        {'price' in uncommittedExpenditure.amount_data && (
                                                            <span className="text-success">{` | New Price: ${uncommittedExpenditure.amount_data.price}`}</span>
                                                        )}
                                                        {'total' in uncommittedExpenditure.amount_data && (
                                                            <span className="text-success">{` | New Total: ${uncommittedExpenditure.amount_data.total}`}</span>
                                                        )}
                                                        {uncommittedExpenditure.expense.price > 0 && ` | Price: ${uncommittedExpenditure.expense.price} `}
                                                        {` | CASH: ${uncommittedExpenditure.originalCashflowObject.cash} | VIK: ${uncommittedExpenditure.originalCashflowObject.vik}`}
                                                    </label>
                                                    {uncommittedExpenditure.expense.type !== 'sport' && (
                                                        <label
                                                            className={'font-italic text-secondary float-right'}
                                                            onClick={() => clickRow(uncommittedExpenditure)}
                                                        >
                                                            <EditIcon className="tw-w-3 tw-h-3" />
                                                            Click row to Edit
                                                        </label>
                                                    )}
                                                </div>
                                            </li>
                                        );
                                    })}
                                </ul>
                            )}
                            <div className="p-3 float-right">
                                {!props.uncommittedExpenditureId && !isLoading && !isRequesting && (
                                    <Button variant="danger" onClick={() => storeCommittedExpenditures(false)}>
                                        Cancel Commit Expenditures
                                    </Button>
                                )}
                                {!props.uncommittedExpenditureId && !isLoading && !isRequesting && (
                                    <Button variant="primary" className="ml-3" onClick={() => storeCommittedExpenditures(true)}>
                                        Commit Expenditures
                                    </Button>
                                )}
                                {!props.uncommittedExpenditureId && !!isRequesting && (
                                    <Button variant="primary" className="ml-3" disabled>
                                        Commit Expenditures Requested
                                    </Button>
                                )}
                                {props.uncommittedExpenditureId && (
                                    <Button
                                        variant="primary"
                                        className="ml-3"
                                        onClick={() => {
                                            window.location.href =
                                                props.committedExpendituresCreateUrl + '?uncommittedExpenditureGroupId=' + props.uncommittedExpenditureGroupId;
                                        }}
                                    >
                                        Back to Commit Expenditures
                                    </Button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <UncommittedExpendituresEditModal
                modalId="edit-uncommitted-expenditure"
                modalRef={uncommittedExpendituresEditModalRef}
                modalElement={uncommittedExpendituresEditModalElement}
                uncommittedExpenditure={updatedUncommittedExpenditure}
                uncommittedExpendituresUpdateUrl={props.uncommittedExpendituresUpdateUrl}
                expenseFundApprovalsUpdateUrl={expenseFundApprovalsUpdateUrl}
                uncommittedExpendituresPreCommitUrl={props.uncommittedExpendituresPreCommitUrl}
                closeHandler={closeHandler}
                updateSuccessHandler={successHandler}
                department={props.department}
                costcenter={props.costcenter}
                isProjectSblExpense={() => isProjectSblExpense(updatedUncommittedExpenditure)}
            />
        </>
    );
}
